<template>
  <v-app id="404">
      <div>
        <div class="error-1"></div>
        <div class="error-2"></div>
        <div class="error-3"><span>요청하신 페이지를 찾을 수 없습니다.</span></div>
        <div class="error-4"><span>방문하시려는 페이지를 다시 한번 확인해주세요. 감사합니다.</span></div>
        <a class="goToBack" @click="goHome()"><div class="error-5"><span>이전 페이지로 이동</span></div></a>
    </div>
  </v-app>
</template>

<script>
export default {
  methods: {
    goHome () {
      this.$router.push({ path: '/' });
    }
  }
};
</script>
<style scoped lang="css">
  
a.goToBack {
  color: inherit;
  text-decoration: none;
  display:block;
  width:240px;
  margin:0 auto;
}

/* error */
.error-1 {
  width: 184px;
  height: 20px;
  margin: 70px auto 200px;
  margin: 0 auto;
  margin-top: 70px;
  margin-bottom: 100px;
}
.connect-post-link-1 {
  margin-bottom: 80px;
}
.error-2 {
  background: url("/static/img/error-sprite-1.png") no-repeat -180px -45px;
  background-size: 612px auto;
  width: 250px;
  height: 230px;
  margin: 0 auto;
  margin-bottom: 93px;
}

.error-3 {
  color: #333;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.error-4 {
  color: #999;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;
}
.error-5 {
  width: 240px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background: #284E96;
  border-radius: 900px;
  text-align: center;
  margin: 0 auto;
}
.connect-post-link-5 {
  width: 200px;
}
.error-6 {
  background: url('/static/img/error-sprite-1.png') no-repeat 1px -284px;
  background-size: 612px auto;
  width: 452px;
  height: 275px;
  margin: 0 auto;
  margin-bottom: 67px;
}
.connect-post-link-6 {
  display: block;
  height: 22px;
  margin: 16px auto;
  width: 140px;
  text-align: center;
  line-height: 22px;
  font-weight: bold;
  color: #6449FC;
}
@media all and (max-width: 900px) {
  .error-1 {
    margin-bottom: 50px;
  }
}
@media all and (max-width: 500px) {
  .error-1 {
    margin: 50px auto;
  }
  .error-2 {
    margin: 50px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Error.vue